import React from 'react';
import {
  Button,
  ButtonGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Typography,
} from '@one-thd/sui-atomic-components';
import PropTypes from 'prop-types';
import { sendAnalyticsWebEvent } from '../../../analytics/sendEvent';
import { ANALYTICS_EVENTS } from '../../../constants';

export const DecisionModal = ({
  isOpen, onClose, href, message, headerTitle, cancelButtonName, confirmButtonName
}) => {
  return (
    <Modal size="sm" open={isOpen} onClose={onClose}>
      <ModalHeader onClose={onClose}>{headerTitle}</ModalHeader>
      <ModalBody>
        <Typography variant="body-base">
          {message}
        </Typography>
      </ModalBody>
      <ModalFooter position="end">
        <ButtonGroup>
          <Button variant="secondary" onClick={onClose}>
            {cancelButtonName}
          </Button>
          <Button
            variant="primary"
            href={href}
            target
            onClick={async () => {
              await sendAnalyticsWebEvent({
                type: ANALYTICS_EVENTS.WEB_WEB_INTERACTION_LINK_CLICKS,
                data: {
                  link: confirmButtonName,
                  page: window.digitalData.page.pageInfo.pageName,
                  region: `${headerTitle} overlay`,
                  pageIDType: 1
                }
              });
            }}
            style={{ textDecoration: 'none' }}
          >
            {confirmButtonName}
          </Button>
        </ButtonGroup>
      </ModalFooter>
    </Modal>
  );
};

DecisionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  href: PropTypes.string.isRequired,
  message: PropTypes.string,
  headerTitle: PropTypes.string,
  cancelButtonName: PropTypes.string.isRequired,
  confirmButtonName: PropTypes.string.isRequired,
};

DecisionModal.defaultProps = {
  message: '',
  headerTitle: '',
};
